import { useEffect, useState } from 'react';

// Cùng mốc 1024px với các khối "Giao diện PC" trong CSS. Chỉ dùng khi không thể xử lý bằng CSS
const QUERY = '(min-width: 1024px)';

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(() => (window.matchMedia ? window.matchMedia(QUERY).matches : false));

  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsDesktop(e.matches);
    setIsDesktop(mql.matches);
    // Safari < 14 không có addEventListener trên MediaQueryList: giữ giá trị lúc tải trang
    mql.addEventListener && mql.addEventListener('change', onChange);
    return () => mql.removeEventListener && mql.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
};

export default useIsDesktop;
